"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Text = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.5 19a.5.5 0 00.5-.5V6h4.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H7v12.5a.5.5 0 00.5.5h1zm13-9H18v8.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V10h-3.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v1a.5.5 0 01-.5.5z", clipRule: "evenodd" })); };
exports.Text = Text;
//# sourceMappingURL=text.js.map